import IconThumbtackSlashSolid from '@/assets/icons/font_awesome/thumbtack-slash-solid.svg?react';
import IconThumbtackSolid from '@/assets/icons/font_awesome/thumbtack-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_search_update } from '@/state/search/remote_search_update';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';

interface Props {
  item: DTOSearchSettings;
}

export function SButtonHistoryListItemPin({ item }: Props) {
  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let item_new = item.clone({ is_pinned: !item.is_pinned });

    await dispatch(remote_search_update(item_new));
  }

  /*
   * RENDERS
   */

  function render_icon() {
    let out = null;

    if (!global_is_mobile) {
      out = IconThumbtackSolid;
    } else if (item.is_pinned) {
      out = IconThumbtackSolid;
    } else {
      out = IconThumbtackSlashSolid;
    }

    return out;
  }

  /*
   * HTML
   */

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_UPDATE)) return <></>;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      className="w-7"
      size="square-5"
      variant="no-border-on-component"
      onClick={onClick}
      Icon={render_icon()}
      iconClassNameBase={`!w-3 !h-3 `}
      iconClassNameHovered={`!text-bar-foreground ${!global_is_mobile && item.is_pinned ? '!rotate-45' : ''}`}
      iconClassNameNonHovered={'!text-bar'}
    />
  );
}
